/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Sale {
    STANDARD = 'STANDARD',
    TEMPORARY = 'TEMPORARY',
    PROFESSIONAL = 'PROFESSIONAL',
    PRIVATE = 'PRIVATE',
}
